import { render, staticRenderFns, recyclableRender, components } from "./headSearch.vue?vue&type=template&id=2f1d196e&scoped=true&"
var renderjs
import script from "./headSearch.vue?vue&type=script&lang=js&"
export * from "./headSearch.vue?vue&type=script&lang=js&"
import style0 from "./headSearch.vue?vue&type=style&index=0&id=2f1d196e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\前端软件\\HBuilderX.3.2.12.20211029\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d196e",
  null,
  false,
  components,
  renderjs
)

export default component.exports